import { useTranslation } from 'react-i18next';

import { Divider, Link, Tag } from '@cfa/react-components';

interface HeaderInnerObject {
  translationString: string;
  value: boolean;
}

type HeaderOuterObject = Record<string, HeaderInnerObject>;

interface ClearFiltersHeaderProps {
  filters: string[];
  aliases: HeaderOuterObject;
  clearFilter: (filter: string) => void;
  clearAllFilters: () => void;
}

const ClearFiltersHeader: React.FC<ClearFiltersHeaderProps> = ({
  filters,
  aliases,
  clearFilter,
  clearAllFilters,
}) => {
  const isVisible = !!filters.length;
  const { t } = useTranslation();

  return (
    <>
      {isVisible && (
        <>
          <Divider variant="fullLength" />
          <div className="my-6 flex flex-wrap items-center gap-2">
            {filters.map(filter => (
              <Tag
                key={filter}
                label={aliases[filter]?.translationString ?? filter}
                onClose={() => clearFilter(filter)}
              />
            ))}
            {!!filters.length && (
              <Link
                onClick={clearAllFilters}
                size="body2"
                variant="standalone"
                className="whitespace-nowrap! underline!"
              >
                {t('Button.clearAll')}
              </Link>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default ClearFiltersHeader;
